export const environment = {
  baseUrl: 'https://quiz.us.aodocs.app',
  apiUrl: '/_ah/api/',
  aodocsUrl: 'https://aodocs.altirnao.com/',
  clientId: '216947375979-hf9pf84bqrblorargpcsobmlduqmnd61.apps.googleusercontent.com',
  version: '1.0.0',
  production: true,
};
